export default __webpack_public_path__ + "static/media/Caixa.8ac1417c.svg";